
import { useState } from 'react';
import { useLocalFavorites } from '@/hooks/useLocalFavorites';
import { useLocalFavoritesData } from '@/hooks/useLocalFavoritesData';
import { LocalFavoritesEmptyState } from './LocalFavoritesEmptyState';
import { LocalFavoritesCollapsedState } from './LocalFavoritesCollapsedState';
import { LocalFavoritesHeader } from './LocalFavoritesHeader';
import { LocalFavoritesGrid } from './LocalFavoritesGrid';

export const LocalFavoritesContainer = () => {
  const { favorites, toggleFavorite, clearFavorites, favoritesCount } = useLocalFavorites();
  const { favoriteVacations, loading } = useLocalFavoritesData(favorites);
  const [showSection, setShowSection] = useState(true);
  
  console.log('LocalFavoritesContainer render - favorites:', favorites);
  console.log('LocalFavoritesContainer render - favoritesCount:', favoritesCount);

  // Show empty state when no favorites
  if (favoritesCount === 0) {
    return <LocalFavoritesEmptyState />;
  }

  // Show collapsed state when section is hidden
  if (!showSection) {
    return (
      <LocalFavoritesCollapsedState 
        favoritesCount={favoritesCount}
        onExpand={() => setShowSection(true)}
      />
    );
  }

  return (
    <div className="container mx-auto px-4 mb-8">
      <div className="bg-gradient-to-r from-red-50 to-pink-50 border border-red-200 rounded-lg p-6">
        <LocalFavoritesHeader
          favoritesCount={favoritesCount}
          onClearFavorites={clearFavorites}
          onCollapse={() => setShowSection(false)}
        />

        <LocalFavoritesGrid
          favoriteVacations={favoriteVacations}
          loading={loading}
          favoritesCount={favoritesCount}
          onToggleFavorite={toggleFavorite}
        />

        <div className="mt-4 text-center">
          <p className="text-sm text-red-600">
            💡 Favorieten worden alleen in deze browsersessie bewaard
          </p>
        </div>
      </div>
    </div>
  );
};
